/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from "react";
import {
  Container,
  Header,
  Form,
  Message,
  Image} from "semantic-ui-react";

import * as CONSTANTS from "../assets/Constants";
import * as LINKS from "../assets/Links";
import LOGO from "../assets/images/logo.png";

class SignUp extends Component {
  state = {
    email: "",
    password: "",
    name: "",
    gender: "",
    branch: "",
    hostelType: "",
    github: "",
    linkedIn: "",
    medium: "",
    mobileNum: "",
    driveImage: "",
    currentDesignation: "",
    areasOfExpertise: "",
    milestones: "",
    vision: "",
    success: false,
    error: false,
    errorMsg: ""
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  renderProfilePicPreview() {
    let preview =
      "https://react.semantic-ui.com/images/avatar/large/christian.jpg";
    // eslint-disable-next-line eqeqeq
    if (this.state.gender == "FEMALE") {
      preview = "https://semantic-ui.com/images/avatar2/large/lindsay.png";
    }
    // eslint-disable-next-line eqeqeq
    if (!this.state.github == "") {
      preview = "https://avatars.githubusercontent.com/" + this.state.github;
    }
    // eslint-disable-next-line eqeqeq
    if (!this.state.driveImage == "") {
      preview = CONSTANTS.DRIVE_URL + this.state.driveImage;
    }
    return <Image size="small" centered src={preview} />;
  }

  handleSubmit() {
    const {
      email,
      password,
      name,
      gender,
      batch,
      branch,
      hostelType,
      regNo    } = this.state;
    // eslint-disable-next-line eqeqeq
    // if (mobileNum.length != 10 || isNaN(mobileNum)) {
    //   this.setState({ errorMsg: "Incorrect Mobile Number" });
    //   this.setState({ error: true });
    //   return;
    // }
    // eslint-disable-next-line no-useless-escape
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      this.setState({ errorMsg: "Incorrect Email address" });
      this.setState({ error: true });
      return;
    }
    fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.createUser, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        user_data: {
          email: email,
          password: password
        },
        member_data: {
          name: name,
          reg_no: regNo,
          branch: branch,
          gender: gender,
          batch: batch,
          hostel_type: hostelType
        },
        detail_data: {
        //   github: github,
        //   linkedin: linkedIn,
        //   medium: medium,
        //   mobile_num: mobileNum,
        //   drive_image: driveImage,
        //   current_designation: currentDesignation,
        //   areas_of_expertise: areasOfExpertise,
        //   milestones: milestones,
        //   vision: vision
        }
      })
    })
      .then(resp => resp.json())
      .then(data => {
        if (!data["success"]) {
          console.log(data);
          this.setState({ error: true, errorMsg: data.error });
        } else {
          // console.log(data);
          this.setState({ success: true });
          console.log("Added! " + data.id + ", " + data.email);
        }
      });
  }

  render() {
    const {
      email,
      password,
      name,
      gender,
      batch,
      branch,
      hostelType,
      regNo    } = this.state;
    return (
      <Container
        fluid
        text
        /* textAlign="center" */ style={{ marginBottom: "3em" }}
      >
      <Image
            src={LOGO}
            size="tiny"
            centered
            style={{ marginTop: "3em", backgroundColor: "#111111" }}
          />
        <Header as="h2" textAlign="center">
          It is going to be a fresh start...
        </Header>
        <Form
          size="large"
          onSubmit={this.handleSubmit}
          error={this.state.error}
        >
          <Form.Input
            fluid
            name="email"
            label="Primary Email"
            icon="mail"
            iconPosition="left"
            placeholder="Only give your primary email"
            value={email}
            onChange={this.handleChange}
            required={true}
          />
          <Form.Input
            fluid
            name="password"
            label="Password (Password is hashed on the backend, don't worry 😅)"
            icon="key"
            type="password"
            iconPosition="left"
            placeholder="Password is hashed on the backend, don't worry 😅"
            value={password}
            onChange={this.handleChange}
            required={true}
          />
          <Form.Input
            fluid
            name="name"
            label="Name (Try to give full name, possibly with initials, lets stay unique)"
            icon="user"
            iconPosition="left"
            placeholder="Try to give full name, possibly with initials, lets stay unique"
            value={name}
            onChange={this.handleChange}
            required={true}
          />
          <Form.Dropdown
            fluid
            name="gender"
            label="Gender"
            placeholder="Gender"
            value={gender}
            onChange={this.handleChange}
            // clearable
            options={[
              { value: "MALE", text: "Male" },
              { value: "FEMALE", text: "Female" }
            ]}
            selection
            required={true}
          />
          <Form.Dropdown
            fluid
            name="batch"
            label="Pass-out Year"
            placeholder="Batch"
            value={batch}
            onChange={this.handleChange}
            // clearable
            options={[
              { value: "2013", text: "2013" },
              { value: "2014", text: "2014" },
              { value: "2015", text: "2015" },
              { value: "2016", text: "2016" },
              { value: "2017", text: "2017" },
              { value: "2018", text: "2018" },
              { value: "2019", text: "2019" },
              { value: "2020", text: "2020" },
              { value: "2021", text: "2021" },
              { value: "2022", text: "2022" },
              { value: "2023", text: "2023" }
            ]}
            selection
            required={true}
          />
          <Form.Dropdown
            fluid
            name="branch"
            label="Branch of Study"
            placeholder="Your brach of study at SASTRA"
            value={branch}
            onChange={this.handleChange}
            // clearable
            options={CONSTANTS.branchesList}
            selection
            required={true}
          />
          <Form.Dropdown
            fluid
            name="hostelType"
            label="Hosteler or Day_Scholar"
            placeholder="Hosteler or Day_Scholar"
            value={hostelType}
            onChange={this.handleChange}
            // clearable
            options={CONSTANTS.hostelTypeList}
            selection
            required={true}
          />
          <Form.Input
            fluid
            name="regNo"
            label="Register Number"
            icon="registered"
            iconPosition="left"
            placeholder="Your registration number at SASTRA"
            value={regNo}
            onChange={this.handleChange}
            required={true}
          />
          {/* <Form.Input
            fluid
            name="mobileNum"
            label="Primary Mobile Number"
            icon="phone"
            iconPosition="left"
            placeholder="Better give your WhatsApp number, no spam from this website..."
            value={mobileNum}
            onChange={this.handleChange}
            // required={true}
          />
          <Form.Input
            fluid
            name="linkedIn"
            label="LinkedIn"
            icon="linkedin"
            iconPosition="left"
            placeholder="Give only your LinkedIn username/handle, not the profile link"
            value={linkedIn}
            onChange={this.handleChange}
          />
          <Message info>
            <Message.Header>
              Your LinkedIn Handle is important for the LinkedIn Badge to show
              up in your Profile.
            </Message.Header>
            <Message.Content>
              Sample LinkedIn handle:
              https://www.linkedin.com/in/-(your-handle)-/
            </Message.Content>
          </Message>
          <Form.Input
            fluid
            name="medium"
            label="Medium"
            icon="medium"
            iconPosition="left"
            placeholder="Give only your Medium username/handle, not the profile link"
            value={medium}
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            name="github"
            label="GitHub"
            icon="github"
            iconPosition="left"
            placeholder="Give only your GitHub username/handle, not the profile link"
            value={github}
            onChange={this.handleChange}
          />
          <Message info>
            <Message.Content>
              Profile Picture for RCS website is gonna be rendered from your
              GitHub profile Picture
            </Message.Content>
          </Message>
          <Popup
            key="driveImage"
            trigger={
              <Form.Input
                fluid
                name="driveImage"
                label="Shared Image Id from your Google Drive"
                icon="picture"
                iconPosition="left"
                placeholder="Make sure the image is shared to (Anyone with Link) and only put the File Id from the link"
                value={driveImage}
                onChange={this.handleChange}
              />
            }
            header="Follow these instructions"
            content="Open Drive at drive.google.com and select a file.
            Click the Share button at the top of the page.
            Click Advanced in the bottom right corner of the sharing box.
            Click Change....
            Choose On - 'Anyone with Link' and 'Choose Can View' and click Save.
            Before closing the sharing box, copy the document ID from the URL in the field below 'Link to share;. The document ID is a string of uppercase and lowercase letters and numbers between slashes in the URL."
            position="right center"
            // disabled={}
          />
          <Message info>
          <Message.Header>
              <Image size="big" src={saveImageDriveInstructions} />
            </Message.Header>
            <Message.Content>
              If you don't have GitHub account, put the file Id of your image
              from your Google Drive.
              <br />
              Make sure that you don't delete it or move it some another folder
              in your Google Drive.
              <br />
              Wait for the image to load, images from Drive load a bit slow,
              better to use Image with less file size.
              <br />
              If you see a broken Image, then something wrong with GitHub handle
              or FileId in drive.
            </Message.Content>
          </Message>
          {this.renderProfilePicPreview()}
          <Form.Input
            fluid
            name="currentDesignation"
            label="Current Designation"
            icon="certificate"
            iconPosition="left"
            placeholder="Designation (or Course)"
            value={currentDesignation}
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            name="areasOfExpertise"
            label="Areas of Expertise"
            icon="hand spock"
            iconPosition="left"
            placeholder="Mention your areas of expertise seperated by commas"
            value={areasOfExpertise}
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            name="milestones"
            label="Professional (or Personal) milestones reached so Far"
            icon="checked calendar"
            iconPosition="left"
            placeholder="Professional (or Personal) milestones reached so Far"
            value={milestones}
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            name="vision"
            label="RCS: your Vision"
            icon="star"
            iconPosition="left"
            placeholder="RCS:your Vision"
            value={vision}
            onChange={this.handleChange}
          /> */}
          <Message positive success={!this.state.success}>
            <Message.Content>Submitted, check your mail inbox</Message.Content>
          </Message>
          <Message error>
            <Message.Content>
              {this.state.errorMsg + ", Reload and Retry Again..."}
            </Message.Content>
          </Message>
          <Message info>
            <Message.Header>
              No need to accpet any terms 🤓.
              <br />
              Sometimes the server might be slow 😑, don't press the submit button more than once 🙄. Wait for the Success Message.
              <br />
              If there is any error, mail the screenshot to the official email address.
            </Message.Header>
          </Message>
          <Form.Button
            color="black"
            size="large"
            type="submit"
            disabled={this.state.error || this.state.success}
          >
            I'm in
          </Form.Button>
        </Form>
      </Container>
    );
  }
}

export default SignUp;
